export type Integration =
  | "perfitapi"
  | "transactional"
  | "webjs"
  | "webhooks"
  | "tiendanube"
  | "mshops"
  | "shopify"
  | "jumpseller"
  | "vtex"
  | "woocommerce"
  | "mercadopago"
  | "fbleadads"
  | "tiendup"
  | "zapier"
  | "storydots"
  | "flowy"
  | "jivochat"
  | "bootic"
  | "ecwid"
  | "tokkobroker"
  | "signos"
  | "tray"
  | "wbuy"
  | "wordpress"
  | "integrately"
  | "magento"
  | "pow"
  | "persat"
  | "wobiz"
  | "meli";

export interface IntegrationInfo {
  id: string;
  image: string;
  name: string;
  requiresActivation?: boolean;
  url?: UrlString;
}

export interface PerfitIntegration extends IntegrationInfo {
  hideOnWhiteLabel: true;
}

export interface ExternalIntegration extends IntegrationInfo {
  redirect?: {
    development: UrlString;
    production: UrlString;
    staging: UrlString;
    testing: UrlString;
  };
}

export const isExternalIntegration = (i: ExternalIntegration | PerfitIntegration): i is ExternalIntegration => {
  return (i as ExternalIntegration).redirect !== undefined;
};

export type IntegrationsInfo = PerfitIntegration | ExternalIntegration;
